export default __webpack_public_path__ + "bank.cf2ac6621e785500bc27.svg";